module.exports = __webpack_public_path__ + "static/img/sou-n@2x.0b32fdd5.png";